import React from "react";
import { CircleHelp, Phone, MessageCircle } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { faqData, navData } from "../../data/mockData";

/* ── FAQ Header ── */

const FAQHeader = () => (
  <div className="text-center mb-12">
    <div className="inline-flex items-center justify-center w-16 h-16 bg-sky-100 rounded-full mb-4">
      <CircleHelp className="w-8 h-8 text-sky-600" />
    </div>
    <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
      {faqData.title}
    </h3>
    <p className="text-lg text-slate-600">{faqData.subtitle}</p>
  </div>
);

/* ── Contact CTA ── */

const ContactCTA = () => (
  <div className="mt-12 text-center">
    <p className="text-slate-600 mb-6">
      Still have questions? We're here to help!
    </p>
    <div className="flex flex-wrap justify-center gap-4">
      <a
        href={`tel:${navData.phoneLink}`}
        className="inline-flex items-center bg-sky-600 hover:bg-sky-700 text-white font-medium px-8 py-2.5 rounded-md shadow transition-colors text-sm"
      >
        <Phone className="w-5 h-5 mr-2" />
        Call Us
      </a>
      <a
        href={navData.whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center bg-green-600 hover:bg-green-700 text-white font-medium px-8 py-2.5 rounded-md shadow transition-colors text-sm"
      >
        <MessageCircle className="w-5 h-5 mr-2" />
        WhatsApp
      </a>
    </div>
  </div>
);

/* ── Main FAQ Section ── */

const FAQSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <FAQHeader />

        <Accordion type="single" collapsible className="space-y-4">
          {faqData.questions.map((item) => (
            <AccordionItem
              key={item.id}
              value={item.id}
              className="bg-white border-2 border-sky-100 rounded-lg px-6 hover:border-sky-300 transition-colors data-[state=open]:border-sky-300"
            >
              <AccordionTrigger className="text-left font-semibold text-slate-900 hover:text-sky-600 hover:no-underline py-4 text-sm">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 pb-4">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <ContactCTA />
      </div>
    </section>
  );
};

export default FAQSection;
